<template>
  <div class="photos-carousel" ref="domRefRoot" @click="isAdventureGuideModalVisible = true">
    <div class="photos-carousel__carousel-wrap">
      <div class="photos-carousel__arrow photos-carousel__arrow--left" @click="carouselPosition -= 1">
        <IconEmbedded name="arrow-left_3" :size="21" color="rgba(0, 0, 0, 1)" style="position: relative; left: 1px" />
      </div>
      <div class="photos-carousel__arrow photos-carousel__arrow--right" @click="carouselPosition += 1">
        <IconEmbedded name="arrow-right_3" :size="21" color="rgba(0, 0, 0, 1)" />
      </div>

      <ul class="photos-carousel__carousel-itself">
        <li
          v-for="(card, index) in infiniteCardsList"
          :key="card.originalIndex"
          :class="{
            'card-snippet': true,
            'card-snippet--invisible': isNaN(index % carouselPosition) || (!isNaN(index % carouselPosition) && (index % carouselPosition === 0 || index % carouselPosition > 3)),
            'photos-carousel__card': true,
            'photos-carousel__card--position-0': index === 0,
            'photos-carousel__card--position-1': index === 1,
            'photos-carousel__card--position-2': index === 2,
            'photos-carousel__card--position-3': index === 3,
            'photos-carousel__card--position-4': index === 4,
          }"
        >
          <!-- Avatars and Name snippet -->
          <!--<div class="avatars-and-name-snippet card-snippet__avatars-and-name-snippet">-->
          <!--  <div class="avatars-and-name-snippet__avatars-wrap">-->
          <!--    <RouterLink-->
          <!--      class="avatars-and-name-snippet__avatar"-->
          <!--      :to="{-->
          <!--        name: 'Pages',-->
          <!--        params: { pageId: card.pageId },-->
          <!--      }"-->
          <!--    >-->
          <!--      <img class="avatars-and-name-snippet__avatar-img" :src="card.creatorAvatar" alt="" />-->
          <!--    </RouterLink>-->
          <!--    <RouterLink-->
          <!--      class="avatars-and-name-snippet__avatar"-->
          <!--      :to="{-->
          <!--        name: 'CreatorProfilePublic',-->
          <!--        params: { creatorId: card.creatorId },-->
          <!--      }"-->
          <!--    >-->
          <!--      <img-->
          <!--        class="avatars-and-name-snippet__avatar-img avatars-and-name-snippet__avatar-img&#45;&#45;contain"-->
          <!--        :src="`https://dev-cdn.shrpa.com/cms/images/orgs/${card.communityAvatar}`"-->
          <!--        alt=""-->
          <!--        draggable="false"-->
          <!--      />-->
          <!--    </RouterLink>-->
          <!--  </div>-->

          <!--  <RouterLink-->
          <!--    class="avatars-and-name-snippet__event-name"-->
          <!--    :to="{-->
          <!--      name: 'CollabSummaryPublic',-->
          <!--      params: {-->
          <!--        communityId: card.pageId,-->
          <!--        collabInputId: card.collabInputId,-->
          <!--      },-->
          <!--    }"-->
          <!--  >-->
          <!--    {{ card?.eventName }}-->
          <!--  </RouterLink>-->
          <!--</div>-->
          <!-- / Avatars and Name snippet -->

          <img class="card-snippet__bg-photo" :src="card?.photoUrl" :alt="card?.eventName" />
        </li>
      </ul>
    </div>

    <ul class="photos-carousel__social-icons-row">
      <li class="photos-carousel__social-icon">
        <IconEmbedded name="instagram" :size="21" color="rgba(17, 48, 66, 0.7)" />
      </li>
      <li class="photos-carousel__social-icon">
        <IconEmbedded name="facebook" :size="21" color="rgba(17, 48, 66, 0.7)" />
      </li>
      <li class="photos-carousel__social-icon">
        <IconEmbedded name="globe_2-5" :size="20" color="rgba(17, 48, 66, 0.7)" />
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
import { ref, computed, watch } from "vue";

// Types
import { CollabSummaryModel } from "@contracts/collabCredits";

// Components
import IconEmbedded from "@components/ui/IconEmbedded.vue";

// Composables
import useSwipes from "@composables/useSwipes";

// DOM refs
const domRefRoot = ref<any>(null);

// Cards list =================================================================
interface CardObj {
  eventName: string;
  photoUrl: string;
  // creatorAvatar: string;
  // communityAvatar: string;
  originalIndex: number;
  // pageId: string;
  // creatorId: string;
  // collabInputId: string;
}

const cardsList = ref<Array<CardObj>>([
  { eventName: "", photoUrl: "https://cdn.shrpa.com/cms/images/expeditions/cc0ac1fa-e46e-4a63-9b7c-a0103039aebb.jpg", originalIndex: 0 },
  { eventName: "", photoUrl: "https://cdn.shrpa.com/cms/images/expeditions/41f13cbb-af67-49db-b03a-282b1a4f2d5f.jpg", originalIndex: 0 },
  { eventName: "", photoUrl: "https://cdn.shrpa.com/cms/images/expeditions/e9fff044-6313-4dd0-ac9d-6e60eb9da664.jpg", originalIndex: 0 },
  { eventName: "", photoUrl: "https://cdn.shrpa.com/cms/images/expeditions/f6761831-54f7-4c12-95c0-648b956dd929.jpg", originalIndex: 0 },
  { eventName: "", photoUrl: "https://cdn.shrpa.com/cms/images/expeditions/ee1697c7-4778-4d91-bb07-41cc31e68605.jpg", originalIndex: 0 }, // fish photo
  { eventName: "", photoUrl: "https://cdn.shrpa.com/cms/images/expeditions/870742ce-22ae-419e-8b59-b2bc4f5330f4.jpg", originalIndex: 0 },
  { eventName: "", photoUrl: "https://cdn.shrpa.com/cms/images/expeditions/146cf29c-9b54-430a-afa1-ef5577780433.jpg", originalIndex: 0 },
  // { eventName: "", photoUrl: "https://cdn.shrpa.com/cms/images/expeditions/d495c472-41a9-4470-af20-de64f3929aa9.jpg", originalIndex: 0 },
  // { eventName: "", photoUrl: "https://cdn.shrpa.com/cms/images/expeditions/879d7fbc-440c-43de-993f-bffd35233204.jpg", originalIndex: 0 },
]);

const infiniteCardsList = computed<Array<CardObj>>(() => {
  if (!cardsList.value.length) {
    return [];
  }

  const visibleCardsCount = 3;
  // "+ 2" is needed to account for the first and the last invisible cards that have to be present in the DOM to make the transition animation possible
  const infiniteCardsList = new Array(visibleCardsCount + 2).fill(null);
  const carouselPositionAbs = carouselPosition.value;

  for (let i = 0; i < infiniteCardsList.length; i++) {
    const targetCard = cardsList.value[(i + carouselPositionAbs) % cardsList.value.length];
    infiniteCardsList[i] = {
      eventName: targetCard.eventName,
      photoUrl: targetCard.photoUrl,
      // creatorAvatar: targetCard.creator.profileImageUri,
      // communityAvatar: targetCard.page.icon,
      originalIndex: 0,
      // pageId: targetCard.page.id,
      // creatorId: targetCard.creator.sherpaId,
      // collabInputId: targetCard.collabDetails.collabInputId,
    } as CardObj;

    if (infiniteCardsList.length > cardsList.value.length) {
      // Fixes the repetition of originalIndex when the number of unique cards is less than visibleCardsCount + 2
      infiniteCardsList[i].originalIndex = i;
    } else {
      infiniteCardsList[i].originalIndex = (i + carouselPositionAbs) % cardsList.value.length;
    }
  }

  return infiniteCardsList;
});

const isAdventureGuideModalVisible = ref<boolean>(false);

// Carousel position ==========================================================
// the carousel position always have to be a positive number in order to make the "infinite cards" array calculation much simpler
// -1 shift is needed to place the cardsList[0] card at the beginning of the visible cards row (
const carouselPosition = ref<number>(cardsList.value.length * 10000 - 1);

watch(cardsList, () => {
  carouselPosition.value = cardsList.value.length * 10000 - 1;
});

// Set up swipes ==============================================================
useSwipes(
  domRefRoot,
  () => (carouselPosition.value -= 1),
  () => (carouselPosition.value += 1)
);
</script>

<style scoped lang="scss">
@use "sass:math";
@import "@/scss/screen-size-ranges.scss";

// Avatars and Name snippet ===================================================
.avatars-and-name-snippet {
  padding: 9px 14px;
  box-sizing: border-box;
  border-radius: 10px;
  display: flex;
  align-items: center;
  background: rgba(255, 255, 255, 0.5);
  backdrop-filter: blur(25px);

  &__avatars-wrap {
    margin-right: 10px;
    display: flex;
  }

  &__avatar {
    width: 47px;
    height: 47px;
    margin-right: -16px;
    border-radius: 100px;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    overflow: hidden;
    background: rgba(255, 255, 255, 1);
    transform: scaleX(1);
    transition: opacity 0.05s ease-in-out;

    &:last-child {
      margin-right: 0;
    }

    &:nth-child(1) {
      z-index: 2;
    }

    &:hover {
      opacity: 0.6;
    }
  }

  &__avatar-img {
    width: 100%;
    height: 100%;
    object-fit: cover;

    &--contain {
      object-fit: contain;
    }
  }

  &__event-name {
    display: -webkit-box !important;
    overflow: hidden !important;
    color: rgba(0, 0, 0, 1);
    font:
      600 16px/19px "Quicksand",
      sans-serif;
    text-decoration: underline;
    text-decoration-color: rgba(0, 0, 0, 0.2);
    text-underline-offset: 2px;
    text-decoration-thickness: 1px;
    text-decoration-style: solid;
    line-clamp: 2 !important;
    -webkit-line-clamp: 2 !important;
    text-overflow: ellipsis !important;
    -webkit-box-orient: vertical !important;
    cursor: pointer;

    &:hover {
      text-decoration: none;
    }
  }
}

// Card snippet ===============================================================
.card-snippet {
  border-radius: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  transform: scale(1) translateZ(1px);
  opacity: 1;
  overflow: hidden;
  box-shadow: 8px 12px 22px 0 rgba(0, 0, 0, 0.19);
  transition:
    top 0.2s ease-in-out,
    left 0.2s ease-in-out,
    transform 0.1s ease-in-out,
    opacity 0.1s ease-in-out;

  &--invisible {
    transform: scale(0.8) translateZ(1px);
    opacity: 0;
    pointer-events: none;
  }

  &__avatars-and-name-snippet {
    width: calc(100% - 30px);
    position: absolute;
    inset: auto auto 25px 15px;
  }

  &__bg-photo {
    width: 100%;
    height: 100%;
    object-fit: cover;
    user-select: none;
  }
}

// Photos carousel ============================================================
.photos-carousel {
  width: 600px;
  height: 450px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  z-index: 0;

  $card-width: 280px;
  $card-aspect-ratio: math.div(10, 13);

  &__carousel-wrap {
    aspect-ratio: $card-aspect-ratio;
    width: $card-width;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    z-index: 0;
  }

  &__arrow {
    width: 50px;
    height: 50px;
    opacity: 0.6;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    z-index: 1;
    cursor: pointer;
    user-select: none;

    &::before {
      content: "";
      width: 100%;
      height: 100%;
      border-radius: 100px;
      position: absolute;
      inset: 0 auto auto 0;
      z-index: -1;
      background: rgba(255, 255, 255, 1);
      transition:
        width 0.07s ease-in-out,
        height 0.07s ease-in-out,
        top 0.07s ease-in-out,
        left 0.07s ease-in-out;
    }

    &:hover::before {
      width: calc(100% + 4px);
      height: calc(100% + 4px);
      inset: -2px auto auto -2px;
    }

    &--left {
      top: calc(50% - 65px);
      left: calc($card-width * -1 / 2 + 17px);
    }

    &--right {
      right: calc($card-width * -1 / 2 + 17px);
      bottom: calc(50% - 65px);
    }
  }

  &__carousel-itself {
    width: 100%;
    height: 100%;
    padding: 0;
    margin: 0;
    position: relative;
    z-index: 0;
    list-style: none;
  }

  &__card {
    aspect-ratio: $card-aspect-ratio;
    width: $card-width;
    position: absolute;

    &--position-0 {
      top: -24%;
      left: -100%;
      z-index: 4;
    }
    &--position-1 {
      top: -12%;
      left: -50%;
      z-index: 3;
    }
    &--position-2 {
      top: 0%;
      left: 0%;
      z-index: 2;
    }
    &--position-3 {
      top: 12%;
      left: 50%;
      z-index: 1;
    }
    &--position-4 {
      top: 24%;
      left: 100%;
      z-index: 0;
    }
  }

  &__social-icons-row {
    gap: 7px;
    padding: 0;
    margin: 0;
    display: flex;
    align-items: center;
    position: absolute;
    inset: auto calc(50% + 150px) 0 auto;
    list-style: none;
  }

  &__social-icon {
    width: 38px;
    height: 38px;
    border-radius: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #e6edf0;
  }
}
// desktop wide -----------------------
@media (min-width: $desktop-wide-min-width) {
}
// desktop ----------------------------
@media (min-width: $desktop-min-width) and (max-width: $desktop-max-width) {
}
// laptop -----------------------------
@media (min-width: $laptop-min-width) and (max-width: $laptop-max-width) {
}
// tablet large -----------------------
@media (min-width: $tablet-large-min-width) and (max-width: $tablet-large-max-width) {
}
// tablet -----------------------------
@media (min-width: $tablet-min-width) and (max-width: $tablet-max-width) {
  .photos-carousel {
  }
}
// mobile -----------------------------
@media (max-width: $mobile-max-width) {
  .photos-carousel {
    transform: scale(0.6);
  }
}
</style>
